import { LegalInfoLinksProps } from "./BCAFooter/LegalInfo";

export function buildLegalInfo(apiModel: any): LegalInfoLinksProps {
	if (
		apiModel &&
		typeof apiModel === "object" &&
		Object.keys(apiModel).length !== 0
	) {
		const nodes = apiModel["@nodes"];

		const legalInfo = nodes.map((node: string) => {
			return {
				id: apiModel[node]["@id"],
				link: apiModel[node]["link"],
				label: apiModel[node]["label"],
				openInNewWindow: apiModel[node]["openInNewWindow"],
				isVisible: apiModel[node]["isVisible"],
			};
		});

		return legalInfo;
	}

	return [];
}
